export const paths = {
    "setupmeeting": "Setup Meetings",
    "my-meetings": "My Meetings",
    "edit-past-meeting":"My Meetings",
    "meeting-summary": "Meetings Summary",
    "calendar":"Audit Calendar",
    "control-reference":"Control-Reference",
    "checklist":"Audit Checklist",
    "observation":"Audit Observations",
    "taskboard":"Task-Board",
    "team-management":"Team-Management",
}
 